module.exports = __webpack_public_path__ + "img/logo.df185c13.png";